<div class="notification-icon-container" (click)="onNotificationClick()">
  <div class="notification-bell">
    <i class="mdi mdi-bell-outline"></i>
    @if (hasUnreadNotifications) {
      <span
        class="notification-badge"
        [class.has-notifications]="hasUnreadNotifications">
        {{ displayCount }}
      </span>
    }
  </div>
</div>
